// import { useCallback, useEffect, useState } from "react";
// import axios from "axios";
// import { FiEye, FiSearch, FiTrash2, FiX } from "react-icons/fi";

// const date = (value) => value ? new Date(value).toLocaleString() : "—";
// const status = (story) => story.status === "deleted" ? "Deleted" : new Date(story.expiresAt) <= new Date() ? "Expired" : "Active";
// const Media = ({ story, detail = false }) => story.mediaType === "video" ? <video src={story.media?.url} controls={detail} muted={!detail} className={detail ? "max-h-[55vh] w-full rounded bg-black" : "h-12 w-12 rounded object-cover"} /> : story.mediaType === "audio" ? <audio src={story.media?.url} controls className={detail ? "w-full" : "w-32"} /> : <img src={story.media?.url} alt="Story media" className={detail ? "max-h-[55vh] w-full rounded object-contain bg-gray-100" : "h-12 w-12 rounded object-cover"} />;

// export default function Stories() {
//   const [stories, setStories] = useState([]), [page, setPage] = useState(1), [search, setSearch] = useState(""), [filter, setFilter] = useState(""), [loading, setLoading] = useState(true), [error, setError] = useState(""), [selected, setSelected] = useState(null), [deleting, setDeleting] = useState(null);
//   const [meta, setMeta] = useState({ currentPage: 1, totalPages: 1, totalStories: 0 });
//   const load = useCallback(async () => { setLoading(true); setError(""); try { const response = await axios.get("/api/v1/admin/stories", { params: { page, limit: 20, search: search || undefined, status: filter || undefined } }); const data = response.data?.data || {}; setStories(data.stories || []); setMeta({ currentPage: data.currentPage || page, totalPages: data.totalPages || 1, totalStories: data.totalStories || 0 }); } catch (requestError) { setError(requestError.response?.data?.error || "Unable to load stories."); } finally { setLoading(false); } }, [page, search, filter]);
//   useEffect(() => { load(); }, [load]);
//   const remove = async (story) => { if (!window.confirm("Remove this story and its Cloudinary media?")) return; setDeleting(story._id); try { await axios.delete(`/api/v1/admin/stories/${story._id}`); setSelected(null); await load(); } catch (requestError) { setError(requestError.response?.data?.error || "Unable to delete story."); } finally { setDeleting(null); } };
//   const setSearchValue = (event) => { setSearch(event.target.value); setPage(1); };
//   const setFilterValue = (event) => { setFilter(event.target.value); setPage(1); };
//   return <div className="min-h-screen p-6 text-[var(--black-text)]"><div className="mb-6 flex items-center justify-between"><div><h1 className="text-3xl font-bold">Stories</h1><p className="text-sm opacity-70">Review image, video, and audio stories.</p></div><span className="rounded bg-purple-100 px-3 py-2 text-purple-800">{meta.totalStories} stories</span></div><div className="rounded-xl border bg-white p-4"><div className="mb-5 flex gap-3"><label className="relative flex-1"><FiSearch className="absolute left-3 top-3 text-gray-400" /><input value={search} onChange={setSearchValue} placeholder="Search caption or owner" className="w-full rounded border py-2 pl-10" /></label><select value={filter} onChange={setFilterValue} className="rounded border px-3"><option value="">All statuses</option><option value="active">Active</option><option value="expired">Expired</option><option value="deleted">Deleted</option></select></div>{error && <p className="mb-3 rounded bg-red-50 p-3 text-red-700">{error}</p>}<div className="overflow-x-auto"><table className="w-full text-sm"><thead><tr className="border-b text-left text-gray-500"><th className="p-3">Media</th><th className="p-3">Owner</th><th className="p-3">Caption</th><th className="p-3">Status</th><th className="p-3">Views</th><th className="p-3">Expires</th><th className="p-3">Actions</th></tr></thead><tbody>{loading ? <tr><td colSpan="7" className="p-10 text-center">Loading…</td></tr> : stories.length === 0 ? <tr><td colSpan="7" className="p-10 text-center">No stories found.</td></tr> : stories.map((story) => <tr key={story._id} className="border-b"><td className="p-3"><Media story={story} /></td><td className="p-3">{story.owner?.fullName || "Deleted user"}</td><td className="max-w-48 truncate p-3">{story.caption || "—"}</td><td className="p-3">{status(story)}</td><td className="p-3">{story.viewCount || 0}</td><td className="p-3">{date(story.expiresAt)}</td><td className="p-3"><button onClick={() => setSelected(story)} className="mr-2 text-purple-700"><FiEye /></button>{story.status !== "deleted" && <button disabled={deleting === story._id} onClick={() => remove(story)} className="text-red-600"><FiTrash2 /></button>}</td></tr>)}</tbody></table></div><div className="mt-5 flex justify-between"><span>Page {meta.currentPage} of {meta.totalPages}</span><div><button disabled={page <= 1} onClick={() => setPage(page - 1)} className="mr-2 rounded border px-3 py-1">Previous</button><button disabled={page >= meta.totalPages} onClick={() => setPage(page + 1)} className="rounded border px-3 py-1">Next</button></div></div></div>{selected && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"><div className="relative w-full max-w-2xl rounded bg-white p-6"><button onClick={() => setSelected(null)} className="absolute right-3 top-3"><FiX /></button><h2 className="mb-4 text-xl font-bold">Story details</h2><Media story={selected} detail /><p className="mt-4">{selected.caption || "—"}</p><p className="mt-2 text-sm">Owner: {selected.owner?.fullName || "Deleted user"} · Views: {selected.viewCount || 0}</p>{selected.status !== "deleted" && <button disabled={deleting === selected._id} onClick={() => remove(selected)} className="mt-5 rounded bg-red-600 px-4 py-2 text-white">Delete story</button>}</div></div>}</div>;
// }






import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { FiEye, FiSearch, FiTrash2, FiX } from "react-icons/fi";

// Format date
const formatDate = (value) => {
  return value ? new Date(value).toLocaleString() : "—";
};

// Get story status
const getStoryStatus = (story) => {
  if (story.status === "deleted") {
    return "Deleted";
  }

  if (new Date(story.expiresAt) <= new Date()) {
    return "Expired";
  }

  return "Active";
};

// Media component
const Media = ({ story, detail = false }) => {
  if (story.mediaType === "video") {
    return (
      <video
        src={story.media?.url}
        controls={detail}
        muted={!detail}
        className={
          detail
            ? "max-h-[55vh] w-full rounded bg-black"
            : "h-12 w-12 rounded object-cover"
        }
      />
    );
  }

  if (story.mediaType === "audio") {
    return (
      <audio
        src={story.media?.url}
        controls
        className={detail ? "w-full" : "w-32"}
      />
    );
  }

  return (
    <img
      src={story.media?.url}
      alt="Story media"
      className={
        detail
          ? "max-h-[55vh] w-full rounded object-contain bg-gray-100"
          : "h-12 w-12 rounded object-cover"
      }
    />
  );
};

export default function Stories() {
  const [stories, setStories] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);
  const [deleting, setDeleting] = useState(null);

  const [meta, setMeta] = useState({
    currentPage: 1,
    totalPages: 1,
    totalStories: 0,
  });

  // Load stories
  const load = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const response = await axios.get("/api/v1/admin/stories", {
        params: {
          page,
          limit: 20,
          search: search || undefined,
          status: filter || undefined,
        },
      });

      const data = response.data?.data || {};

      setStories(data.stories || []);

      setMeta({
        currentPage: data.currentPage || page,
        totalPages: data.totalPages || 1,
        totalStories: data.totalStories || 0,
      });
    } catch (requestError) {
      setError(
        requestError.response?.data?.error ||
          "Unable to load stories."
      );
    } finally {
      setLoading(false);
    }
  }, [page, search, filter]);

  // Fetch stories whenever page/search/filter changes
  useEffect(() => {
    load();
  }, [load]);

  // Delete story
  const remove = async (story) => {
    const confirmed = window.confirm(
      "Remove this story and its Cloudinary media?"
    );

    if (!confirmed) {
      return;
    }

    setDeleting(story._id);

    try {
      await axios.delete(`/api/v1/admin/stories/${story._id}`);

      setSelected(null);

      await load();
    } catch (requestError) {
      setError(
        requestError.response?.data?.error ||
          "Unable to delete story."
      );
    } finally {
      setDeleting(null);
    }
  };

  // Search handler
  const setSearchValue = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  // Filter handler
  const setFilterValue = (event) => {
    setFilter(event.target.value);
    setPage(1);
  };

  return (
    <div className="min-h-screen p-6 text-[var(--black-text)]">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Stories</h1>

          <p className="text-sm opacity-70">
            Review image, video, and audio stories.
          </p>
        </div>

        <span className="rounded bg-purple-100 px-3 py-2 text-purple-800">
          {meta.totalStories} stories
        </span>
      </div>

      {/* Main Card */}
      <div className="rounded-xl border bg-white p-4">
        {/* Search & Filter */}
        <div className="mb-5 flex gap-3">
          <label className="relative flex-1">
            <FiSearch className="absolute left-3 top-3 text-gray-400" />

            <input
              value={search}
              onChange={setSearchValue}
              placeholder="Search caption or owner"
              className="w-full rounded border py-2 pl-10"
            />
          </label>

          <select
            value={filter}
            onChange={setFilterValue}
            className="rounded border px-3"
          >
            <option value="">All statuses</option>
            <option value="active">Active</option>
            <option value="expired">Expired</option>
            <option value="deleted">Deleted</option>
          </select>
        </div>

        {/* Error */}
        {error && (
          <p className="mb-3 rounded bg-red-50 p-3 text-red-700">
            {error}
          </p>
        )}

        {/* Stories Table */}
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left text-gray-500">
                <th className="p-3">Media</th>
                <th className="p-3">Owner</th>
                <th className="p-3">Caption</th>
                <th className="p-3">Status</th>
                <th className="p-3">Views</th>
                <th className="p-3">Expires</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>

            <tbody>
              {/* Loading */}
              {loading ? (
                <tr>
                  <td colSpan="7" className="p-10 text-center">
                    Loading…
                  </td>
                </tr>
              ) : stories.length === 0 ? (
                /* Empty State */
                <tr>
                  <td colSpan="7" className="p-10 text-center">
                    No stories found.
                  </td>
                </tr>
              ) : (
                /* Stories */
                stories.map((story) => (
                  <tr key={story._id} className="border-b">
                    {/* Media */}
                    <td className="p-3">
                      <Media story={story} />
                    </td>

                    {/* Owner */}
                    <td className="p-3">
                      {story.owner?.fullName || "Deleted user"}
                    </td>

                    {/* Caption */}
                    <td className="max-w-48 truncate p-3">
                      {story.caption || "—"}
                    </td>

                    {/* Status */}
                    <td className="p-3">
                      {getStoryStatus(story)}
                    </td>

                    {/* Views */}
                    <td className="p-3">
                      {story.viewCount || 0}
                    </td>

                    {/* Expiry */}
                    <td className="p-3">
                      {formatDate(story.expiresAt)}
                    </td>

                    {/* Actions */}
                    <td className="p-3">
                      {/* View */}
                      <button
                        type="button"
                        onClick={() => setSelected(story)}
                        className="mr-2 text-purple-700"
                        title="View Story"
                      >
                        <FiEye />
                      </button>

                      {/* Delete */}
                      {story.status !== "deleted" && (
                        <button
                          type="button"
                          disabled={deleting === story._id}
                          onClick={() => remove(story)}
                          className="text-red-600 disabled:cursor-not-allowed disabled:opacity-50"
                          title="Delete Story"
                        >
                          <FiTrash2 />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-5 flex justify-between">
          <span>
            Page {meta.currentPage} of {meta.totalPages}
          </span>

          <div>
            <button
              type="button"
              disabled={page <= 1}
              onClick={() => setPage(page - 1)}
              className="mr-2 rounded border px-3 py-1 disabled:cursor-not-allowed disabled:opacity-50"
            >
              Previous
            </button>

            <button
              type="button"
              disabled={page >= meta.totalPages}
              onClick={() => setPage(page + 1)}
              className="rounded border px-3 py-1 disabled:cursor-not-allowed disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Story Details Modal */}
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)]  p-4">
          <div className="relative w-full max-w-2xl rounded border p-6">
            {/* Close Button */}
            <button
              type="button"
              onClick={() => setSelected(null)}
              className="absolute right-3 top-3"
              title="Close"
            >
              <FiX />
            </button>

            {/* Modal Title */}
            <h2 className="mb-4 text-xl font-bold">
              Story details
            </h2>

            {/* Media */}
            <Media story={selected} detail />

            {/* Caption */}
            <p className="mt-4">
              {selected.caption || "—"}
            </p>

            {/* Story Info */}
            <p className="mt-2 text-sm">
              Owner:{" "}
              {selected.owner?.fullName || "Deleted user"}{" "}
              · Views: {selected.viewCount || 0}
            </p>

            {/* Delete Button */}
            {selected.status !== "deleted" && (
              <button
                type="button"
                disabled={deleting === selected._id}
                onClick={() => remove(selected)}
                className="mt-5 rounded bg-red-600 px-4 py-2 text-white disabled:cursor-not-allowed disabled:opacity-50"
              >
                {deleting === selected._id
                  ? "Deleting..."
                  : "Delete story"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}